import { useReducer } from "react";
var initialState = {
    openMenu: null
};
var menuReducer = function(state, action) {
    switch(action.type){
        case "TOGGLE_MENU":
            return {
                openMenu: state.openMenu === action.index ? null : action.index
            };
        default:
            return state;
    }
};
/**
 * Convenience hook for controlling mobile menus when multiple menus are needed
 * (only one should be visible at once)
 */ export var useMobileMenus = function() {
    var ref = useReducer(menuReducer, initialState), openMenu = ref[0].openMenu, dispatch = ref[1];
    var setOpenMenu = function(index) {
        return dispatch({
            type: "TOGGLE_MENU",
            index: index
        });
    };
    return {
        openMenu: openMenu,
        setOpenMenu: setOpenMenu
    };
};
